/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Email_MissingInputs */

const en_portalsignin_email_missing = /** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the email address your agency has on file.`)
};

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const ar_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const he_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const ur_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const es_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const fr_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const de_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const pt_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const hi_portalsignin_email_missing = en_portalsignin_email_missing;

/** @type {(inputs: Portalsignin_Email_MissingInputs) => LocalizedString} */
const bn_portalsignin_email_missing = en_portalsignin_email_missing;

/**
* | output |
* | --- |
* | "Enter the email address your agency has on file." |
*
* @param {Portalsignin_Email_MissingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_email_missing = /** @type {((inputs?: Portalsignin_Email_MissingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Email_MissingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_email_missing(inputs)
	if (locale === "he") return he_portalsignin_email_missing(inputs)
	if (locale === "ur") return ur_portalsignin_email_missing(inputs)
	if (locale === "es") return es_portalsignin_email_missing(inputs)
	if (locale === "fr") return fr_portalsignin_email_missing(inputs)
	if (locale === "de") return de_portalsignin_email_missing(inputs)
	if (locale === "pt") return pt_portalsignin_email_missing(inputs)
	if (locale === "hi") return hi_portalsignin_email_missing(inputs)
	if (locale === "bn") return bn_portalsignin_email_missing(inputs)
	return /** @type {LocalizedString} */ ("Enter the email address your agency has on file.")
});